import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../../colorVars';
import { modifySoftOrderProvideDetails } from '../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import { CancelOrderButton } from '../../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import IncrementButton from '../../../../../../../../atomic/buttons/incrementButton/IncrementButton';
import { EditableTableField } from '../../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { TableSelect } from '../../../../../../../../atomic/inputs/tableSelect/TableSelect';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import style from '../../IndividualTacticStyle.module.css';
import { FtfcTacticPanelHeader } from './FtfcTacticPanelHeader';
const timeUnitMap = {
  MINUTES: 'Minute',
  DAYS: 'Day',
  WEEKS: 'Week',
  MONTHS: 'Month',
  QUARTERS: 'Quarter',
  YEARS: 'Year',
};
export const FtfcTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const [addCandleDurationValue, setAddCandleDurationValue] = useState(1);
    const [addTimeUnitValue, setAddTimeUnitValue] = useState('MINUTES');
    const { tradePlanStore } = useWebsocketStore();
    const tacticId =
      tradePlanStore.tradePlans[tradePlanId].setupFilters['FTFC']?.tacticId ??
      null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const longArr = softOrder?.value.tacticValue.long ?? null;
    const shortArr = softOrder?.value.tacticValue.short ?? null;
    const arr = longArr ? longArr : shortArr;

    if (!tacticId || !softOrder) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <FtfcTacticPanelHeader />
            <tbody>
              {arr.map(({ candleDuration, timeUnit }, index) => {
                return (
                  <tr key={'' + candleDuration + timeUnit}>
                    <td className={style.labelTd}>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        {index + 1}
                      </Body3>
                    </td>
                    <td className={style.labelTd}>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        {candleDuration}
                      </Body3>
                    </td>
                    <td className={style.labelTd}>
                      <Body3 fontWeight={700} color={colors.lightGrey}>
                        {timeUnitMap[timeUnit]}
                      </Body3>
                    </td>
                    <td className={style.inputTd}>
                      <CancelOrderButton
                        margin="5px 0 0 0"
                        width={15}
                        clickHandler={() => {
                          modifySoftOrderProvideDetails({
                            softOrder,
                            details: {
                              candleDuration,
                              timeUnit,
                              type: 'remove',
                            },
                          });
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Add
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={addCandleDurationValue}
                    updateValue={(newValue) =>
                      setAddCandleDurationValue(newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </td>
                <td className={style.labelTd}>
                  <TableSelect
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                    value={addTimeUnitValue}
                    onChange={(newValue) => setAddTimeUnitValue(newValue)}
                    options={[
                      { label: 'Minute', value: 'MINUTES' },
                      { label: 'Day', value: 'DAYS' },
                      { label: 'Week', value: 'WEEKS' },
                      { label: 'Month', value: 'MONTHS' },
                      { label: 'Quarter', value: 'QUARTERS' },
                      { label: 'Year', value: 'YEARS' },
                    ]}
                  />
                </td>
                <td className={style.inputTd}>
                  <IncrementButton
                    color={colors.white}
                    backgroundColor={colors.blue}
                    width={10}
                    stroke={2}
                    handleClick={() => {
                      modifySoftOrderProvideDetails({
                        softOrder,
                        details: {
                          candleDuration: addCandleDurationValue,
                          timeUnit: addTimeUnitValue,
                          type: 'add',
                        },
                      });
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

FtfcTacticPanel.tabsRole = 'TabPanel';
